import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { interval } from 'rxjs';
import { startWith } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { normalizeBaseUrl } from '../../environments/environment.utils';
import { SharedService } from './shared.service';

const CHAVE = 'tk-efemero';

/**
 * Links de download/exportação (href) e o WebSocket não conseguem enviar o header Authorization.
 * O backend emite um token efêmero (10 min, só para download e WebSocket), renovado aqui
 * automaticamente. O token de sessão (JWT) nunca vai na URL.
 */
export function tokenEfemero(): string | null {
  try {
    const token = sessionStorage.getItem(CHAVE);
    if (!token) {
      return null;
    }
    return Number(token.split('.')[1]) > Date.now() ? token : null;
  } catch {
    return null;
  }
}

export function urlComToken(url: string): string {
  const token = tokenEfemero();
  if (!token) {
    return url;
  }
  return url + (url.indexOf('?') >= 0 ? '&' : '?') + 'access_token=' + encodeURIComponent(token);
}

@Injectable({
  providedIn: 'root'
})
export class TokenEfemeroService {

  private renovando = false;

  constructor(private http: HttpClient) {
    interval(5000).pipe(startWith(0)).subscribe(() => this.verificar());
  }

  private verificar() {
    if (!SharedService.getInstance().isLoggedIn()) {
      try {
        sessionStorage.removeItem(CHAVE);
      } catch {
        // sem armazenamento
      }
      return;
    }
    const token = tokenEfemero();
    const expiraEm = token ? Number(token.split('.')[1]) : 0;
    if (!token || expiraEm - Date.now() < 120000) {
      this.renovar();
    }
  }

  private renovar() {
    if (this.renovando) {
      return;
    }
    this.renovando = true;
    this.http.get(`${normalizeBaseUrl(environment.api)}/api/download-token`, { responseType: 'text' }).subscribe(
      token => {
        try {
          sessionStorage.setItem(CHAVE, token);
        } catch {
          // sem armazenamento
        }
        this.renovando = false;
      },
      () => {
        this.renovando = false;
      });
  }

}
